import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CatBadge } from "blocks-nextjs/blocks-react/components/Badge";
import { format } from "date-fns";
import React from "react";
const MINUTES_PER_HOUR = 60;
const HOURS_IN_HALF_DAY = 12;
const ASSET_NAME_PREVIEW_LENGTH = 3;
import chargingIcon from "../../assets/Charging.gif";
import errorChargingOption from "../../assets/ErrorChargingOption.png";
import { getBatteryIcon } from "../../lib/getBatteryIcon";
import { getBatteryIconByMake, getBatteryMakeDisplayName, getCESTLocalTime } from "../../pages/Projects/ProjectDetails.helper";
import { getTimezoneAbbr } from "../../shared/helper";
import { formatTimestampWithTimezone } from "../../shared/timestampHelpers";
const FutureChargingOptions = (props) => {
    const { chargeFilter, chargingOptionsData, time, timePanel, timeUnits, timezone } = props;
    const safeTz = timezone || "Europe/Amsterdam";
    const getLocaleTime = () => {
        if (!time || !timeUnits)
            return "";
        let hours = 0;
        let minutes = 0;
        if (typeof time === "string" && time.includes(":")) {
            const [h, m] = time.split(":");
            hours = Number(h);
            minutes = Number(m);
        }
        else {
            hours = Number(time);
            minutes = 0;
        }
        if (timeUnits === "PM" && hours < HOURS_IN_HALF_DAY) {
            hours += HOURS_IN_HALF_DAY;
        }
        if (timeUnits === "AM" && hours === HOURS_IN_HALF_DAY) {
            hours = 0;
        }
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        return `${format(date, "p")}`; // Append timezone abbreviation
    };
    const subtractMinutesFromTime = (minutesToSubtract) => {
        if (!time || !timeUnits)
            return "";
        let hours = 0;
        let minutes = 0;
        if (typeof time === "string" && time.includes(":")) {
            const [h, m] = time.split(":");
            hours = Number(h);
            minutes = Number(m);
        }
        else {
            hours = Number(time);
            minutes = 0;
        }
        if (timeUnits === "PM" && hours < HOURS_IN_HALF_DAY) {
            hours += HOURS_IN_HALF_DAY;
        }
        if (timeUnits === "AM" && hours === HOURS_IN_HALF_DAY) {
            hours = 0;
        }
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes - minutesToSubtract);
        return `${format(date, "p")}`; // Append timezone abbreviation
    };
    const addMinutesToTime = (extraMinutes) => {
        if (!time || !timeUnits)
            return "";
        let hours = 0;
        let minutes = 0;
        if (typeof time === "string" && time.includes(":")) {
            const [h, m] = time.split(":");
            hours = Number(h);
            minutes = Number(m);
        }
        else {
            hours = Number(time);
            minutes = 0;
        }
        if (timeUnits === "PM" && hours < HOURS_IN_HALF_DAY) {
            hours += HOURS_IN_HALF_DAY;
        }
        if (timeUnits === "AM" && hours === HOURS_IN_HALF_DAY) {
            hours = 0;
        }
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes + extraMinutes);
        return `${format(date, "p")}`; // Append timezone abbreviation
    };
    const convertMinutesToHours = (minutes) => {
        if (minutes > MINUTES_PER_HOUR) {
            const hours = Math.floor(minutes / MINUTES_PER_HOUR);
            const newMinutes = minutes % MINUTES_PER_HOUR;
            return `${hours} hr ${newMinutes} min`;
        }
        return `${minutes}min`;
    };
    // Direct charge travel time
    const getDirectTravelTimeText = (chargeOption, timePanel) => {
        if (timePanel === "Completion") {
            return `${subtractMinutesFromTime(Math.round(Number(chargeOption.directChargeToMachine.machineChargeTime)) +
                Math.round(Number(chargeOption.directChargeToMachine.totalTravelTime)))} - ${subtractMinutesFromTime(Math.round(Number(chargeOption.directChargeToMachine.machineChargeTime)))} ${getTimezoneAbbr(safeTz)}`;
        }
        if (timePanel === "Arrival") {
            return `${subtractMinutesFromTime(Math.round(Number(chargeOption.directChargeToMachine.totalTravelTime)))} - ${getLocaleTime()} ${getTimezoneAbbr(safeTz)}`;
        }
        if (timePanel === "Departure") {
            // Travel Time = User entered time + Total travel time
            return `${getLocaleTime()} - ${addMinutesToTime(Math.round(Number(chargeOption.directChargeToMachine.totalTravelTime)))} ${getTimezoneAbbr(safeTz)}`;
        }
        return null;
    };
    // Direct charge completion time
    const getDirectCompletionTimeText = (chargeOption, timePanel) => {
        if (timePanel === "Completion") {
            return getLocaleTime() + ` ${getTimezoneAbbr(safeTz)}`;
        }
        if (timePanel === "Arrival") {
            return (addMinutesToTime(Math.round(Number(chargeOption.directChargeToMachine.machineChargeTime))) +
                ` ${getTimezoneAbbr(safeTz)}`);
        }
        if (timePanel === "Departure") {
            // Completion time = user entered time + machineChargeTime
            return (addMinutesToTime(Math.round(Number(chargeOption.directChargeToMachine.completionTime))) +
                ` ${getTimezoneAbbr(safeTz)}`);
        }
        return null;
    };
    // Through charge travel time
    const getThroughTravelTimeText = (chargeOption, timePanel) => {
        const station = chargeOption.throughChargeStation?.[0];
        if (!station)
            return null;
        if (timePanel === "Completion") {
            return `${subtractMinutesFromTime(Math.round(Number(station.machineChargeTime)) + Math.round(Number(station.totalTravelTime)))} - ${subtractMinutesFromTime(Math.round(Number(station.machineChargeTime)))} ${getTimezoneAbbr(safeTz)}`;
        }
        if (timePanel === "Arrival") {
            return `${subtractMinutesFromTime(Math.round(Number(station.totalTravelTime)))} - ${getLocaleTime()} ${getTimezoneAbbr(safeTz)}`;
        }
        if (timePanel === "Departure") {
            // Travel Time = User entered time + throughChargeStation totalTravelTime
            return `${getLocaleTime()} - ${addMinutesToTime(Math.round(Number(station.totalTravelTime)))} ${getTimezoneAbbr(safeTz)}`;
        }
        return null;
    };
    // Through charge completion time
    const getThroughCompletionTimeText = (chargeOption, timePanel) => {
        const station = chargeOption.throughChargeStation?.[0];
        if (!station)
            return null;
        if (timePanel === "Completion") {
            return getLocaleTime() + ` ${getTimezoneAbbr(safeTz)}`;
        }
        if (timePanel === "Arrival") {
            return addMinutesToTime(Math.round(Number(station.machineChargeTime))) + ` ${getTimezoneAbbr(safeTz)}`;
        }
        if (timePanel === "Departure") {
            // Completion time = user entered time + throughChargeStation machineChargeTime
            return addMinutesToTime(Math.round(Number(station.completionTime))) + ` ${getTimezoneAbbr(safeTz)}`;
        }
        return null;
    };
    const getEarliestCompletionTime = (isFastest) => {
        const assets = Array.isArray(chargingOptionsData?.assets) ? chargingOptionsData.assets : [];
        const completionTimes = assets.map((data) => {
            const options = Array.isArray(data?.chargeOptions) ? data.chargeOptions : [];
            return options.map((chargeOption) => {
                const direct = chargeOption?.directChargeToMachine;
                const through0 = chargeOption?.throughChargeStation?.[0];
                if (!direct && !through0)
                    return undefined;
                const directTarget = Number(direct?.machineTargetSoc);
                const throughTarget = Number(through0?.machineTargetSoc || through0?.machineTargetSoC);
                const targetMatch = directTarget === Number(chargeFilter) || throughTarget === Number(chargeFilter);
                if (targetMatch || isFastest) {
                    const directComp = direct?.completionTime ? Number(direct.completionTime) : undefined;
                    const throughComp = through0?.completionTime ? Number(through0.completionTime) : undefined;
                    if (directComp !== null &&
                        directComp !== undefined &&
                        throughComp !== null &&
                        throughComp !== undefined)
                        return Math.min(Math.round(directComp), Math.round(throughComp));
                    if (directComp !== null && directComp !== undefined)
                        return Math.round(directComp);
                    if (throughComp !== null && throughComp !== undefined)
                        return Math.round(throughComp);
                }
                return undefined;
            });
        });
        const filtered = completionTimes.flat().filter((t) => t !== undefined);
        if (!filtered.length)
            return 0;
        return Math.min(...filtered);
    };
    const earliestCompletionTime = getEarliestCompletionTime(true);
    const maxChargeCompletionTime = getEarliestCompletionTime(false);
    const renderEarliestCompletionTimeBadges = (completionTime, machineTargetSoC) => {
        if (completionTime === earliestCompletionTime &&
            completionTime === maxChargeCompletionTime &&
            machineTargetSoC === Number(chargeFilter)) {
            return (_jsxs("div", { className: "pr-[12px] flex text-sm flex-col gap-1 items-end h-[52px] justify-between w-[13%]", "data-test": "fastest-max-charge", children: [_jsx(CatBadge, { text: "Fastest", variant: "green" }), _jsx(CatBadge, { text: "Max Charge", variant: "grey" })] }));
        }
        else if (completionTime === earliestCompletionTime) {
            return (_jsx("div", { className: "pr-[12px] flex text-sm flex-col gap-1 items-end h-[52px] justify-center w-[13%]", "data-test": "fastest-charge", children: _jsx(CatBadge, { text: "Fastest", variant: "green" }) }));
        }
        else if (completionTime === maxChargeCompletionTime) {
            return (_jsx("div", { className: "pr-[12px] flex text-sm flex-col gap-1 items-end h-[52px] justify-center w-[13%]", "data-test": "max-charge", children: _jsx(CatBadge, { text: "Max Charge", variant: "grey" }) }));
        }
        return (_jsx("div", { className: "pr-[12px] flex text-sm flex-col items-end h-[52px] justify-between w-[13%]", "data-test": "max-charge" }));
    };
    // Helpers to compute current zoned time minutes (CEST or provided timezone) and user-entered completion minutes
    const getHourMinuteForTimezone = (tz) => {
        const parts = new Intl.DateTimeFormat("en-GB", {
            hour: "2-digit",
            hourCycle: "h23",
            minute: "2-digit",
            timeZone: tz
        })
            .formatToParts(new Date())
            .reduce((acc, p) => {
            if (p.type === "hour")
                acc.hour = Number(p.value);
            if (p.type === "minute")
                acc.minute = Number(p.value);
            return acc;
        }, { hour: 0, minute: 0 });
        return parts;
    };
    const targetedCompletionTime = (() => {
        if ((timePanel !== "Completion" && timePanel !== "Arrival") || !time || !timeUnits)
            return null;
        let h = 0;
        let m = 0;
        if (typeof time === "string" && time.includes(":")) {
            const [hs, ms] = time.split(":");
            h = Number(hs);
            m = Number(ms);
        }
        else if (typeof time === "number") {
            h = Number(time);
            m = 0;
        }
        else {
            return null;
        }
        if (Number.isNaN(h) || Number.isNaN(m))
            return null;
        if (timeUnits === "PM" && h < HOURS_IN_HALF_DAY)
            h += HOURS_IN_HALF_DAY;
        if (timeUnits === "AM" && h === HOURS_IN_HALF_DAY)
            h = 0;
        return h * MINUTES_PER_HOUR + m;
    })();
    const currentCESTMinutes = (() => {
        if ((timePanel !== "Completion" && timePanel !== "Arrival") || targetedCompletionTime === null)
            return null;
        const tz = timezone || "Europe/Amsterdam";
        const { hour, minute } = getHourMinuteForTimezone(tz);
        return hour * MINUTES_PER_HOUR + minute;
    })();
    return (_jsx("div", { "data-testid": "future-charging-options", children: Array.isArray(chargingOptionsData?.assets) &&
            chargingOptionsData.assets.map((data, index) => {
                return (_jsx("div", { className: "text-[16px] p-[5px]", "data-test": `charging-options-${index + 1}`, children: Array.isArray(data.chargeOptions) &&
                        data.chargeOptions.map((chargeOption, optIndex) => {
                            if (!chargeOption?.essMetaData || !chargeOption?.directChargeToMachine)
                                return null;
                            const { throughChargeStation = [] } = chargeOption;
                            const hasThroughChargeStations = throughChargeStation.length > 0;
                            const make = getBatteryMakeDisplayName(chargeOption.essMetaData?.make);
                            // Format timestamp for display - handle time-only format specially
                            // Use shared helper to format timestamps (handles both ISO and time-only formats)
                            const lastUpdatedSoCTimestamp = chargeOption?.essMetaData.lastUpdatedSoCTimestamp;
                            const { formattedTime: formattedTimestamp, timezoneAbbr: timezoneAbbrFromHelper } = formatTimestampWithTimezone(lastUpdatedSoCTimestamp, timezone, "default", (ts) => getCESTLocalTime(ts) || "");
                            // Fallback to local timezone abbreviation if no project timezone available
                            const timezoneAbbrText = timezone
                                ? timezoneAbbrFromHelper
                                : getTimezoneAbbr(safeTz);
                            // Completion feasibility check (only in Completion panel)
                            let completionTimeError = false;
                            if (timePanel === "Completion" &&
                                targetedCompletionTime !== null &&
                                currentCESTMinutes !== null) {
                                const diffMinutes = targetedCompletionTime - currentCESTMinutes;
                                const machineChargeTime = Number(chargeOption?.directChargeToMachine?.machineChargeTime);
                                if (!Number.isNaN(machineChargeTime) &&
                                    diffMinutes >= 0 &&
                                    diffMinutes < Math.ceil(machineChargeTime)) {
                                    completionTimeError = true;
                                }
                            }
                            if (completionTimeError) {
                                return (_jsxs("div", { className: "bg-white rounded-xl mb-[16px] py-4 border-[2px] border-[#e9e5e5] border-solid", "data-test": "charge-option-error-card", children: [_jsxs("div", { className: "flex justify-between mx-3 align-center", children: [_jsxs("div", { className: "flex battery-details", children: [_jsx("img", { alt: "Assets", className: "w-10 h-12 mr-4 flex align-center", "data-test": "Battery-Icon", src: getBatteryIconByMake(chargeOption.essMetaData.make) }), _jsxs("div", { className: "flex flex-col", children: [_jsx("div", { children: _jsxs("div", { className: "font-bold", children: [chargeOption.essMetaData.assetName.slice(0, ASSET_NAME_PREVIEW_LENGTH), " ", "| ", chargeOption.essMetaData.batteryCapacity, " kWh"] }) }), _jsx("div", { className: "text-xs font-semibold", children: chargeOption.essMetaData.serialNumber
                                                                        ? `${chargeOption.essMetaData.serialNumber} - ${make}`
                                                                        : make }), _jsxs("div", { className: "text-gray-600 text-xs", "data-test": "last-updated-time", children: ["Last updated: ", formattedTimestamp, " ", timezoneAbbrText] })] })] }), _jsxs("div", { className: "flex flex-col justify-center soc", children: [_jsxs("div", { className: "flex flex-row font-bold items-center", children: [_jsxs("span", { className: "mr-[7px] text-xl", children: [Math.round(chargeOption.essMetaData.soc), "%"] }), _jsx("span", { children: chargeOption.essMetaData.reportingStatus ===
                                                                        "Charging" ? (_jsx("img", { alt: "charging.gif", className: "w-[24px] h-[14px]", src: chargingIcon })) : (getBatteryIcon(Number(chargeOption.essMetaData.soc))) })] }), _jsx("div", { className: "text-gray-500 text-xs", children: "Current SoC" })] })] }), _jsx("div", { className: "mt-[16px] mx-3 border-b-2 border-b-gray-200" }), _jsxs("div", { className: "flex flex-col items-center justify-center py-6", children: [_jsx("img", { alt: "Completion time insufficient", className: "max-h-[140px] object-contain", "data-test": "completion-time-error-image", src: errorChargingOption }), _jsx("p", { className: "text-bold text-gray-600 text-sm mt-4 text-center", children: "Machine cannot be charged in given completion time" })] })] }, chargeOption.essMetaData.assetId));
                            }
                            return (_jsxs("div", { className: "bg-white rounded-xl mb-[16px] py-4 border-[2px] border-[#e9e5e5] border-solid", children: [_jsxs("div", { className: "flex justify-between mx-3 align-center", children: [_jsxs("div", { className: "flex battery-details", children: [_jsx("img", { alt: "Assets", className: "w-10 h-12 mr-4 flex align-center", "data-test": "Battery-Icon", src: getBatteryIconByMake(chargeOption.essMetaData.make) }), _jsxs("div", { className: "flex flex-col", children: [_jsx("div", { children: _jsxs("div", { className: "font-bold", children: [chargeOption.essMetaData.assetName.slice(0, ASSET_NAME_PREVIEW_LENGTH), " ", "| ", chargeOption.essMetaData.batteryCapacity, " kWh"] }) }), _jsx("div", { className: "text-xs font-semibold", children: chargeOption.essMetaData.serialNumber
                                                                    ? `${chargeOption.essMetaData.serialNumber} - ${make}`
                                                                    : make }), _jsxs("div", { className: "text-gray-600 text-xs", "data-test": "last-updated-time", children: ["Last updated: ", formattedTimestamp, " ", timezoneAbbrText] })] })] }), _jsxs("div", { className: "flex flex-col justify-center soc", children: [_jsxs("div", { className: "flex flex-row font-bold items-center", children: [_jsxs("span", { className: "mr-[7px] text-xl", children: [Math.round(chargeOption.essMetaData.soc), "%"] }), _jsx("span", { children: chargeOption.essMetaData.reportingStatus === "Charging" ? (_jsx("img", { alt: "charging.gif", className: "w-[24px] h-[14px]", src: chargingIcon })) : (getBatteryIcon(Number(chargeOption.essMetaData.soc))) })] }), _jsx("div", { className: "text-gray-500 text-xs", children: "Current SoC" })] })] }), _jsx("div", { className: "mt-[16px] mx-3 border-b-2 border-b-gray-200" }), _jsxs("div", { className: "flex mt-[16px] justify-evenly w-full battery-charging", children: [_jsxs("div", { className: "flex-column w-[12%] content-center", children: [_jsx("div", { className: "font-bold text-base", children: "Direct" }), _jsx("div", { className: "text-gray-600 text-xs", children: "to machine" })] }), _jsxs("div", { className: "flex-column w-[22%] content-center", children: [_jsx("div", { className: "font-bold text-base", children: getDirectTravelTimeText(chargeOption, timePanel) }), _jsx("div", { className: "text-gray-600 text-xs", children: "Travel time" })] }), _jsxs("div", { className: "flex-column w-[15%] content-center", children: [_jsx("div", { className: "font-bold text-base", children: convertMinutesToHours(Math.round(Number(chargeOption.directChargeToMachine.machineChargeTime))) }), _jsx("div", { className: "text-gray-600 text-xs", children: "Charging machine" })] }), _jsxs("div", { className: "flex-column w-[15%] content-center", children: [_jsx("div", { className: "font-bold text-base", children: getDirectCompletionTimeText(chargeOption, timePanel) }), _jsx("div", { className: "text-gray-600 text-xs", children: "Completion time" })] }), _jsxs("div", { className: "flex-column w-[15%] content-center", children: [_jsxs("div", { className: "flex font-bold text-base", children: [Math.round(Number(chargeOption.directChargeToMachine.machineTargetSoc)), "%", _jsx("span", { className: "ml-[5px] h-[16px]", children: getBatteryIcon(Number(chargeOption.directChargeToMachine.machineTargetSoc)) })] }), _jsx("div", { className: "text-gray-600 text-xs", children: "Machine SoC" })] }), renderEarliestCompletionTimeBadges(Math.round(Number(chargeOption?.directChargeToMachine?.completionTime)), Math.round(Number(chargeOption?.directChargeToMachine?.machineTargetSoc)))] }), hasThroughChargeStations &&
                                        Number(chargeOption.directChargeToMachine.machineTargetSoc) !==
                                            Number(chargeFilter) &&
                                        (() => {
                                            // Check if additionalTravelTime validation applies
                                            let showTravelTimeError = false;
                                            if ((timePanel === "Arrival" || timePanel === "Completion") &&
                                                targetedCompletionTime !== null &&
                                                currentCESTMinutes !== null) {
                                                const diffMinutes = targetedCompletionTime - currentCESTMinutes;
                                                const totalTravelTime = Math.round(Number(chargeOption.throughChargeStation?.[0]
                                                    ?.totalTravelTime || 0));
                                                if (!Number.isNaN(totalTravelTime) && diffMinutes >= 0) {
                                                    if (diffMinutes < totalTravelTime) {
                                                        showTravelTimeError = true;
                                                    }
                                                    else {
                                                        const station = chargeOption.throughChargeStation?.[0];
                                                        const machineChargeTime = Math.round(Number(station?.machineChargeTime || 0));
                                                        const stationTotalTravelTime = Math.round(Number(station?.totalTravelTime || 0));
                                                        if (timePanel === "Completion") {
                                                            // Calculate start travel time in minutes: targetedCompletionTime - (machineChargeTime + totalTravelTime)
                                                            const startTravelTimeMinutes = targetedCompletionTime -
                                                                (machineChargeTime + stationTotalTravelTime);
                                                            if (startTravelTimeMinutes <= currentCESTMinutes) {
                                                                showTravelTimeError = true;
                                                            }
                                                            else {
                                                                showTravelTimeError = false;
                                                            }
                                                        }
                                                        else if (timePanel === "Arrival") {
                                                            // Calculate start travel time in minutes: targetedCompletionTime - totalTravelTime
                                                            const startTravelTimeMinutes = targetedCompletionTime - stationTotalTravelTime;
                                                            if (startTravelTimeMinutes <= currentCESTMinutes) {
                                                                showTravelTimeError = true;
                                                            }
                                                            else {
                                                                showTravelTimeError = false;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            return (_jsxs(_Fragment, { children: [_jsx("div", { className: "mt-[16px] mx-3 border-b-2 border-b-gray-200" }), _jsxs("div", { className: `flex justify-evenly mt-[16px] battery-charging ${showTravelTimeError ? "ml-3" : ""}`, children: [_jsxs("div", { className: "flex-column w-[12%] content-center", children: [_jsxs("div", { className: "font-bold text-base", children: ["+", convertMinutesToHours(Math.round(Number(chargeOption
                                                                                .throughChargeStation?.[0]
                                                                                .additionalTravelTime)))] }), _jsx("div", { className: "text-gray-600 text-xs", children: "Watthub" })] }), showTravelTimeError ? (_jsxs("div", { className: "flex items-center w-[100%]", children: [_jsx("img", { alt: "Completion time insufficient", className: "h-[50px] object-contain", "data-test": "completion-time-error-image", src: errorChargingOption }), _jsxs("p", { className: "text-bold text-gray-600 ml-3 text-sm text-center", children: ["Machine cannot be charged in given", " ", timePanel?.toLowerCase(), " time"] })] })) : (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex-column w-[22%] content-center", children: [_jsx("div", { className: "font-bold text-base", children: getThroughTravelTimeText(chargeOption, timePanel) }), _jsx("div", { className: "text-gray-600 text-xs", children: "Travel time" })] }), _jsxs("div", { className: "flex-column w-[15%] content-center", children: [_jsx("div", { className: "font-bold text-base", children: `${convertMinutesToHours(Math.round(Number(chargeOption.throughChargeStation?.[0].machineChargeTime)))}` }), _jsx("div", { className: "text-gray-600 text-xs", children: "Charging machine" })] }), _jsxs("div", { className: "flex-column w-[15%] content-center", children: [_jsx("div", { className: "font-bold text-base", children: getThroughCompletionTimeText(chargeOption, timePanel) }), _jsx("div", { className: "text-gray-600 text-xs", children: "Completion time" })] }), _jsxs("div", { className: "flex-column w-[15%] content-center", children: [_jsxs("div", { className: "flex font-bold text-base", children: [Math.round(Number(chargeOption
                                                                                        .throughChargeStation?.[0]
                                                                                        .machineTargetSoc)), "%", _jsx("span", { className: "ml-[5px] h-[16px]", children: getBatteryIcon(Math.round(Number(chargeOption
                                                                                            .throughChargeStation?.[0]
                                                                                            .machineTargetSoc))) })] }), _jsx("div", { className: "text-gray-600 text-xs", children: "Machine SoC" })] }), renderEarliestCompletionTimeBadges(Math.round(Number(chargeOption
                                                                        ?.throughChargeStation?.[0]
                                                                        ?.completionTime)), Math.round(Number(chargeOption
                                                                        ?.throughChargeStation?.[0]
                                                                        .machineTargetSoc)))] }))] })] }));
                                        })()] }, `${data.assetId || "asset"}-${chargeOption?.essMetaData?.assetId || "ess"}-${optIndex}`));
                        }) }, data.assetId || `asset-${index}`));
            }) }));
};
export default FutureChargingOptions;
